/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { brandColors, themeColors } from "./EOSThemeProvider"
import { Grid } from "@cd2/components"

export function ToggleSwitch({
  value,
  onChange,
  disabled,
  label,
  small,
}: {
  value: boolean
  disabled?: boolean
  label?: string
  small?: boolean
  onChange: (value: boolean) => void
}) {
  const trackH = small ? 18 : 24
  const trackW = small ? 36 : 50
  const knobSize = small ? 12 : 18
  const knobOn = small ? trackW - knobSize - 3 : 28
  return (
    <Grid columns={["max-content", "max-content"]} gap={8} alignItems="center">
      {label && (
        <span
          css={css`
            font-weight: 600;
          `}
        >
          {label}
        </span>
      )}
      <div
        css={css`
          height: ${trackH}px;
          width: ${trackW}px;
          border-radius: ${trackH / 2}px;
          padding: 3px;
          background-color: ${value ? brandColors.darkMint : themeColors.grey};
          position: relative;
          cursor: ${disabled ? "not-allowed" : "pointer"};
          opacity: ${disabled ? 0.5 : 1};
        `}
        onClick={disabled ? undefined : () => onChange(!value)}
      >
        <div
          css={css`
            height: ${knobSize}px;
            width: ${knobSize}px;
            border-radius: ${knobSize / 2}px;
            position: absolute;
            left: ${value ? `${knobOn}px` : "3px"};
            top: 3px;
            background-color: white;
            box-shadow: 0px 0px 2px ${themeColors.grey};
            transition: left 0.2s ease-in-out;
          `}
        />
      </div>
    </Grid>
  )
}
